export default __webpack_public_path__ + "static/media/folder.34d79b93.png";